import React from 'react';
import clsx from 'clsx';

const SmallTitle = ({
  className,
  children,
  ...other
}) => {
  return <p className={clsx('text-uppercase fs-18 fw-medium mb-2', className)} {...other}>{children}</p>
}

export default SmallTitle
